function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import ArrowRightOutlineIcon from './arrow-right-outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowRightIcon(props) {
  return ___EmotionJSX(ArrowRightOutlineIcon, props);
}
export function ArrowRightIconSmall(props) {
  return ___EmotionJSX(ArrowRightOutlineIcon, _extends({
    size: "small"
  }, props));
}